import { useState } from "react";
import { formattedAmount } from "../../utils/helpers/Functions.helper"; // ← your helper

const PriceTooltip = ({ mrp, discount, specialPrice }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-flex items-center">
      {/* Trigger button + Icon */}
      <button
        type="button"
        aria-label="Show price breakdown"
        className="
          text-gray-500 
          hover:text-gray-700 
          focus:outline-none 
          focus:ring-2 
          focus:ring-gray-400 
          rounded-full 
          transition-colors
          p-1           // ← small padding – looks good
        "
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <svg
          className="h-7 w-7"           // ← BIGGER & nice looking size
          // Try also: h-8 w-8  or  h-6 w-6
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
          />
        </svg>
      </button>

      {/* Tooltip */}
      {isVisible && (
        <div
          className="
            absolute 
            z-50 
            left-full 
            top-1/2 
            -translate-y-1/2 
            ml-3               // ← distance from icon
            w-72               // a bit wider – looks more premium
            p-4 
            bg-white 
            rounded-lg 
            shadow-xl 
            border border-gray200
            text-sm
          "
        >
          <div className="font-semibold text-gray800 mb-3">
            Price details
          </div>

          <div className="space-y-2.5">
            {/* MRP */}
            <div className="flex justify-between text-gray600">
              <span>Maximum Retail Price</span>
              <span className="">{formattedAmount(mrp)}</span>
            </div>

            {/* Discount */}
            <div className="flex justify-between text-gray600">
              <span>Discount</span>
              <span className="">- {formattedAmount(discount)}</span>
            </div>

            {/* Final price */}
            <div className="flex justify-between font-semibold text-gray900 pt-2 border-t border-gray200">
              <span>Special Price</span>
              <span className="text-green700">{formattedAmount(specialPrice)}</span>
            </div>
          </div>

          {/* Tiny arrow pointing to the icon */}
          {/* <div
            className="
              absolute 
              -left-2 
              top-1/2 
              -translate-y-1/2 
              w-4 
              h-4 
              rotate-45 
              bg-white 
              border-l 
              border-t 
              border-gray-200
            "
          /> */}
        </div>
      )}
    </div>
  );
};

export default PriceTooltip;